import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { WaremaIconButton } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-instructions-link',
    imports: [TranslatePipe, WaremaIconButton],
    templateUrl: './instructions-link.component.html',
    styleUrls: ['./instructions-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstructionsLinkComponent {
    public readonly linkTranslationKey = input('');
    public readonly linkSrc = input('');

    public openLink(): void {
        window.open(this.linkSrc(), '_blank');
    }
}
